import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessProviderId, MemberQuery, MarketplaceExtendedQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QRCodeModule } from 'angularx-qrcode';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import * as ɵngcc6 from 'angularx-qrcode';
import * as ɵngcc7 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc9 from '@ngx-translate/core';

function MemberPurchaseListItemComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "div", 23);
    ɵngcc0.ɵɵelementStart(3, "span", 24);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate2("zoom-call-btn d-flex align-items-center justify-content-center rounded ", "bg-" + ctx_r2.purchaseItem.theme, " ", "text-on-" + ctx_r2.purchaseItem.theme, "");
    ɵngcc0.ɵɵproperty("routerLink", "/zoom/" + ctx_r2.purchaseItem.LogId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.purchaseItem.ProcessProviderId === ctx_r2.ProcessProvider.VirtualEvent ? ɵngcc0.ɵɵpipeBind1(5, 6, "marketplace-redeem-zoom") : ɵngcc0.ɵɵpipeBind1(6, 8, "marketplace-redeem-now"), " ");
} }
function MemberPurchaseListItemComponent_ng_container_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelement(1, "hr", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "div", 27);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 28);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.purchaseItem.BarcodeText);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 2, "wallet.unique.code.title"));
} }
function MemberPurchaseListItemComponent_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "div", 23);
    ɵngcc0.ɵɵelementStart(3, "span", 24);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate2("zoom-call-btn d-flex align-items-center justify-content-center rounded ", "bg-" + ctx_r4.purchaseItem.theme, " ", "text-on-" + ctx_r4.purchaseItem.theme, "");
    ɵngcc0.ɵɵproperty("routerLink", "/zoom/" + ctx_r4.purchaseItem.LogId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.purchaseItem.ProcessProviderId === ctx_r4.ProcessProvider.VirtualEvent ? ɵngcc0.ɵɵpipeBind1(5, 6, "marketplace-redeem-zoom") : ɵngcc0.ɵɵpipeBind1(6, 8, "marketplace-redeem-now"), " ");
} }
function MemberPurchaseListItemComponent_ng_container_0_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "tune");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 31);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "wallet.attribute.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(attribute_r9.ValueName);
} }
function MemberPurchaseListItemComponent_ng_container_0_div_26_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const customField_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(customField_r12.Value);
} }
function MemberPurchaseListItemComponent_ng_container_0_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "post_add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MemberPurchaseListItemComponent_ng_container_0_div_26_ng_container_4_Template, 3, 1, "ng-container", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "wallet.custom.field.screenreader"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.purchaseItem.CustomFields);
} }
function MemberPurchaseListItemComponent_ng_container_0_div_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 35);
    ɵngcc0.ɵɵelementStart(2, "div", 36);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 37);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div");
    ɵngcc0.ɵɵelementStart(9, "label", 38);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "fgbcl-short-long-description", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "marketplace.wallet.date.purchase"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(7, 6, ctx_r7.purchaseItem.ProcessDate, ctx_r7.dateOption.LongDateFormat));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 9, "wallet.description"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("description", ctx_r7.purchaseItem.DescriptionText);
} }
function MemberPurchaseListItemComponent_ng_container_0_ng_container_33_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 40);
    ɵngcc0.ɵɵelementStart(2, "div", 41);
    ɵngcc0.ɵɵelement(3, "qrcode", 42);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("qrdata", ctx_r14.purchaseItem.BarcodeText)("size", 256)("level", "M")("usesvg", true);
} }
function MemberPurchaseListItemComponent_ng_container_0_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MemberPurchaseListItemComponent_ng_container_0_ng_container_33_ng_container_1_Template, 4, 4, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.purchaseItem.ProcessProviderId != ctx_r8.ProcessProvider.UniqueCode && ctx_r8.purchaseItem.ProcessProviderId != ctx_r8.ProcessProvider.VirtualEvent);
} }
const _c0 = function (a0) { return { notOpen: a0 }; };
function MemberPurchaseListItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, MemberPurchaseListItemComponent_ng_container_0_ng_container_2_Template, 7, 10, "ng-container", 0);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelement(5, "img", 4);
    ɵngcc0.ɵɵpipe(6, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 7);
    ɵngcc0.ɵɵtemplate(11, MemberPurchaseListItemComponent_ng_container_0_div_11_Template, 8, 4, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, MemberPurchaseListItemComponent_ng_container_0_ng_container_12_Template, 7, 10, "ng-container", 0);
    ɵngcc0.ɵɵelement(13, "hr", 9);
    ɵngcc0.ɵɵelementStart(14, "div", 10);
    ɵngcc0.ɵɵelementStart(15, "div", 11);
    ɵngcc0.ɵɵelementStart(16, "div", 2);
    ɵngcc0.ɵɵelementStart(17, "div", 12);
    ɵngcc0.ɵɵelementStart(18, "span", 13);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵtext(20, "emoji_events");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "span", 14);
    ɵngcc0.ɵɵtext(22);
    ɵngcc0.ɵɵpipe(23, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(24, MemberPurchaseListItemComponent_ng_container_0_div_24_Template, 6, 4, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 2);
    ɵngcc0.ɵɵtemplate(26, MemberPurchaseListItemComponent_ng_container_0_div_26_Template, 5, 4, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "div", 17);
    ɵngcc0.ɵɵelementStart(28, "div");
    ɵngcc0.ɵɵelementStart(29, "button", 18);
    ɵngcc0.ɵɵlistener("click", function MemberPurchaseListItemComponent_ng_container_0_Template_button_click_29_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.ShowMoreInfo = !ctx_r15.ShowMoreInfo; });
    ɵngcc0.ɵɵelementStart(30, "div");
    ɵngcc0.ɵɵelement(31, "div", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(32, MemberPurchaseListItemComponent_ng_container_0_div_32_Template, 13, 11, "div", 20);
    ɵngcc0.ɵɵtemplate(33, MemberPurchaseListItemComponent_ng_container_0_ng_container_33_Template, 2, 1, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.purchaseItem.ProcessProviderId == ctx_r0.ProcessProvider.VirtualEvent);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(6, 15, ctx_r0.purchaseItem.ItemImageURL || ctx_r0.purchaseItem.ImageURL || ctx_r0.purchaseItem.ItemThumbnailURL || ctx_r0.purchaseItem.ThumbnailURL, "7"), ɵngcc0.ɵɵsanitizeUrl)("useDefault", true)("loyaltyType", "marketplace");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.purchaseItem.DisplayName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.purchaseItem.ProcessProviderId == ctx_r0.ProcessProvider.UniqueCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.purchaseItem.ProcessProviderId == ctx_r0.ProcessProvider.VirtualEvent);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(19, 18, "purchase.wallet.points.spent.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(23, 20, ctx_r0.purchaseItem.PointsValue, "PTS"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.attributes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.purchaseItem.CustomFields && ctx_r0.purchaseItem.CustomFields.length);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattributeInterpolate1("aria-label", "", ctx_r0.purchaseItem.DisplayName, " wallet item - See More");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(23, _c0, !ctx_r0.ShowMoreInfo));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.ShowMoreInfo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fgbWebsiteContentFeatureFlag", "feature.flag.wallet.barcode");
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 49);
    ɵngcc0.ɵɵlistener("click", function MemberPurchaseListItemComponent_ng_container_1_ng_template_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); ɵngcc0.ɵɵnextContext(); const _r17 = ɵngcc0.ɵɵreference(3); return _r17.toggle("ngb-panel-i-{{purchaseItem.LogId}}"); });
    ɵngcc0.ɵɵelementStart(1, "div", 50);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelement(3, "img", 4);
    ɵngcc0.ɵɵpipe(4, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 51);
    ɵngcc0.ɵɵelementStart(9, "div");
    ɵngcc0.ɵɵelementStart(10, "button", 52);
    ɵngcc0.ɵɵelementStart(11, "div");
    ɵngcc0.ɵɵelement(12, "div", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(4, 5, ctx_r18.purchaseItem.ItemImageURL || ctx_r18.purchaseItem.ImageURL || ctx_r18.purchaseItem.ItemThumbnailURL || ctx_r18.purchaseItem.ThumbnailURL, "7"), ɵngcc0.ɵɵsanitizeUrl)("useDefault", true)("loyaltyType", "marketplace");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.purchaseItem.DisplayName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattributeInterpolate1("aria-label", "", ctx_r18.purchaseItem.DisplayName, " wallet item - See More");
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 59);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "tune");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 31);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "wallet.attribute.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(attribute_r26.ValueName);
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_10_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const customField_r29 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(customField_r29.Value);
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 62);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3, "post_add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_10_ng_container_4_Template, 3, 1, "ng-container", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "wallet.custom.field.screenreader"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r25.purchaseItem.CustomFields);
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 58);
    ɵngcc0.ɵɵelementStart(2, "div", 59);
    ɵngcc0.ɵɵelementStart(3, "span", 13);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵtext(5, "emoji_events");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "span", 14);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_9_Template, 6, 4, "div", 60);
    ɵngcc0.ɵɵtemplate(10, MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_div_10_Template, 5, 4, "div", 61);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(4, 4, "purchase.wallet.points.spent.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(8, 6, ctx_r23.purchaseItem.PointsValue, "PTS"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r23.attributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r23.purchaseItem.CustomFields);
} }
function MemberPurchaseListItemComponent_ng_container_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 54);
    ɵngcc0.ɵɵtemplate(2, MemberPurchaseListItemComponent_ng_container_1_ng_template_6_ng_container_2_Template, 11, 9, "ng-container", 0);
    ɵngcc0.ɵɵelementStart(3, "div", 55);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 56);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 57);
    ɵngcc0.ɵɵelementStart(10, "label", 38);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(13, "fgbcl-short-long-description", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r19.purchaseItem.CustomFields || !!ctx_r19.purchaseItem.AttributeValues);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 5, "marketplace.wallet.date.redeemed"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(8, 7, ctx_r19.purchaseItem.ProcessDate, ctx_r19.dateOption.LongDateFormat));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 10, "wallet.description"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("description", ctx_r19.purchaseItem.DescriptionText);
} }
function MemberPurchaseListItemComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 43);
    ɵngcc0.ɵɵelementStart(2, "ngb-accordion", 44, 45);
    ɵngcc0.ɵɵelementStart(4, "ngb-panel", 46);
    ɵngcc0.ɵɵtemplate(5, MemberPurchaseListItemComponent_ng_container_1_ng_template_5_Template, 13, 8, "ng-template", 47);
    ɵngcc0.ɵɵtemplate(6, MemberPurchaseListItemComponent_ng_container_1_ng_template_6_Template, 14, 12, "ng-template", 48);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("destroyOnHide", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "ngb-panel-i-", ctx_r1.purchaseItem.LogId, "");
} }
class MemberPurchaseListItemComponent {
    constructor(memberQuery, marketplaceExtendedQuery) {
        this.memberQuery = memberQuery;
        this.marketplaceExtendedQuery = marketplaceExtendedQuery;
        this.ProcessProvider = ProcessProviderId;
        this.ShowMoreInfo = false;
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        this.redeemedText = this.purchaseItem.RedeemStatus === 0 ? 'Claim Now' : 'Claimed';
        this.memberQuery.userContext$.pipe(takeUntil(this._destroyed$)).subscribe((userContext) => {
            if (this.purchaseItem.AttributeValues && userContext && userContext.lcid) {
                this.attributes = this.marketplaceExtendedQuery.getLocalisedAttributeValuesFromArray(this.purchaseItem.AttributeValues, +userContext.lcid);
            }
        });
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
MemberPurchaseListItemComponent.ɵfac = function MemberPurchaseListItemComponent_Factory(t) { return new (t || MemberPurchaseListItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MarketplaceExtendedQuery)); };
MemberPurchaseListItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MemberPurchaseListItemComponent, selectors: [["fgbcl-member-purchase-list-item"]], inputs: { purchaseItem: "purchaseItem", dateOption: "dateOption" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "card", "redeem-card", "border-0", "rounded", "py-3", "bg-marketplace-wallet"], [1, "row"], [1, "col-3", "d-flex", "justify-content-left", "align-items-center"], ["alt", "", "draggable", "false", 1, "purchase-list-image", "shadow", "rounded", 3, "src", "useDefault", "loyaltyType"], [1, "col-9"], [1, "marketplace-wallet-title", "purchase-title", "text-left"], [1, ""], ["class", "w-100", 4, "ngIf"], [1, "mt-3", "mx-2", "mb-3"], [1, "row", "px-2"], [1, "col-12", "pl-1"], [1, "col-5", "d-flex", "align-items-center"], ["role", "img", 1, "material-icons", "redeem-list-item-icons", "text-grey", "mr-1"], [1, "marketplace-wallet-points"], ["class", "col-7 d-flex align-items-center", 4, "ngFor", "ngForOf"], ["class", "col-12 d-flex align-items-center pb-0 pt-3", 4, "ngIf"], [1, "col-12", "d-flex", "justify-content-center", "align-items-center", "pt-3"], ["type", "button", 1, "btn", "py-1", "dropdown-tog", 3, "ngClass", "click"], [1, "icon", "icon-arrow-1-up", "wallet-arrow-icon", "d-flex", "align-items-center"], ["class", "row", 4, "ngIf"], [4, "fgbWebsiteContentFeatureFlag"], [1, "d-flex", "d-lg-none", "justify-content-center", "align-items-center", "zoom-container", "mb-2"], [3, "routerLink"], [1, "ml-1", "font-weight-bold"], [1, "w-100"], [1, "text-center", "font-weight-bold"], [1, "unique-code-item"], [1, "pb-2", "unique-code-title"], [1, "d-none", "d-lg-flex", "justify-content-center", "align-items-center", "zoom-container"], [1, "col-7", "d-flex", "align-items-center"], [1, "marketplace-wallet-attributes"], [1, "col-12", "d-flex", "align-items-center", "pb-0", "pt-3"], [4, "ngFor", "ngForOf"], [1, "marketplace-wallet-custom-field", "pr-1"], [1, "wallet-content", "col-12"], [1, "marketplace-wallet-date-redeemed", "pt-5"], [1, "font-size-14", "mb-3"], [1, "marketplace-wallet-description"], [3, "description"], [1, "d-block", "d-lg-none"], [1, "qr", "d-flex", "justify-content-center"], [3, "qrdata", "size", "level", "usesvg"], [1, "wallet-container"], [1, "w-100", 3, "destroyOnHide"], ["a", "ngbAccordion"], [3, "id"], ["ngbPanelHeader", ""], ["ngbPanelContent", "", "class", "content-dropdown"], [3, "click"], [1, "row", "p-3"], [1, "col-12", "d-flex", "justify-content-center", "align-items-center", "mb-2"], ["type", "button", "ngbPanelToggle", "", 1, "btn", "py-1", "dropdown-tog"], [1, "icon", "icon-arrow-1-down", "marketplace-arrow-icon", "d-flex", "align-items-center"], [1, "content", "col-12", "pl-4", "pr-4"], [1, "marketplace-wallet-date-redeemed", "pt-3"], [1, "mb-3"], [1, "pb-4", "mb-2"], [1, "row", "pt-4"], [1, "col-6", "d-flex", "align-items-center", "pb-3"], ["class", "col-6 d-flex align-items-center pb-3", 4, "ngFor", "ngForOf"], ["class", "col-12 d-flex align-items-center pb-0", 4, "ngIf"], [1, "col-12", "d-flex", "align-items-center", "pb-0"]], template: function MemberPurchaseListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MemberPurchaseListItemComponent_ng_container_0_Template, 34, 25, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, MemberPurchaseListItemComponent_ng_container_1_Template, 7, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.purchaseItem.RedeemStatus);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.purchaseItem.RedeemStatus);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.ImgDefaultDirective, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc3.WebsiteContentFeatureFlagDirective, ɵngcc4.RouterLink, ɵngcc5.ShortLongDescriptionComponent, ɵngcc6.QRCodeComponent, ɵngcc7.NgbAccordion, ɵngcc7.NgbPanel, ɵngcc7.NgbPanelHeader, ɵngcc7.NgbPanelContent, ɵngcc7.NgbPanelToggle], pipes: [ɵngcc8.ContentImagePipe, ɵngcc9.TranslatePipe, ɵngcc8.FortressCurrencyPipe, ɵngcc2.DatePipe], styles: [".purchase-list-image[_ngcontent-%COMP%], .purchase-list-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:50px;height:50px}.purchase-title[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.zoom-container[_ngcontent-%COMP%]{height:unset}@media (max-width:991px){.zoom-container[_ngcontent-%COMP%]{height:115px}}.zoom-container[_ngcontent-%COMP%]   .zoom-call-btn[_ngcontent-%COMP%]{height:34px;width:142px;font-size:.875rem;font-weight:700}.redeem-card[_ngcontent-%COMP%]{padding:.75rem 1.25rem;min-height:170px}@media (max-width:991px){.redeem-card[_ngcontent-%COMP%]{min-height:307px}}.btn.notOpen[_ngcontent-%COMP%]{transform:rotate(180deg)}.icon-arrow-1-down[_ngcontent-%COMP%]{height:23px}"] });
MemberPurchaseListItemComponent.ctorParameters = () => [
    { type: MemberQuery },
    { type: MarketplaceExtendedQuery }
];
MemberPurchaseListItemComponent.propDecorators = {
    purchaseItem: [{ type: Input }],
    dateOption: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MemberPurchaseListItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-member-purchase-list-item',
                template: "<ng-container *ngIf=\"!purchaseItem.RedeemStatus\">\r\n  <div class=\"card redeem-card border-0 rounded py-3 bg-marketplace-wallet\">\r\n    <ng-container *ngIf=\"purchaseItem.ProcessProviderId == ProcessProvider.VirtualEvent\">\r\n      <div class=\"d-flex d-lg-none justify-content-center align-items-center zoom-container mb-2\">\r\n        <div\r\n          class=\"zoom-call-btn d-flex align-items-center justify-content-center rounded {{ 'bg-' + purchaseItem.theme }} {{\r\n            'text-on-' + purchaseItem.theme\r\n          }}\"\r\n          [routerLink]=\"'/zoom/' + purchaseItem.LogId\"\r\n        >\r\n          <span class=\"ml-1 font-weight-bold\">\r\n            {{\r\n              purchaseItem.ProcessProviderId === ProcessProvider.VirtualEvent\r\n                ? ('marketplace-redeem-zoom' | translate)\r\n                : ('marketplace-redeem-now' | translate)\r\n            }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <div class=\"row\">\r\n      <div class=\"col-3 d-flex justify-content-left align-items-center\">\r\n        <img\r\n          class=\"purchase-list-image shadow rounded\"\r\n          [src]=\"\r\n            purchaseItem.ItemImageURL || purchaseItem.ImageURL || purchaseItem.ItemThumbnailURL || purchaseItem.ThumbnailURL\r\n              | contentImage: '7'\r\n          \"\r\n          alt=\"\"\r\n          [useDefault]=\"true\"\r\n          [loyaltyType]=\"'marketplace'\"\r\n          draggable=\"false\"\r\n        />\r\n      </div>\r\n      <div class=\"col-9\">\r\n        <div class=\"marketplace-wallet-title purchase-title text-left\">{{ purchaseItem.DisplayName }}</div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Unqiue Code-->\r\n    <div class=\"\">\r\n      <div class=\"w-100\" *ngIf=\"purchaseItem.ProcessProviderId == ProcessProvider.UniqueCode\">\r\n        <hr class=\"mt-3 mx-2 mb-3\" />\r\n        <div class=\"text-center font-weight-bold\">\r\n          <div class=\"unique-code-item\">{{ purchaseItem.BarcodeText }}</div>\r\n          <div class=\"pb-2 unique-code-title\">{{ 'wallet.unique.code.title' | translate }}</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <ng-container *ngIf=\"purchaseItem.ProcessProviderId == ProcessProvider.VirtualEvent\">\r\n      <div class=\"d-none d-lg-flex justify-content-center align-items-center zoom-container\">\r\n        <div\r\n          class=\"zoom-call-btn d-flex align-items-center justify-content-center rounded {{ 'bg-' + purchaseItem.theme }} {{\r\n            'text-on-' + purchaseItem.theme\r\n          }}\"\r\n          [routerLink]=\"'/zoom/' + purchaseItem.LogId\"\r\n        >\r\n          <span class=\"ml-1 font-weight-bold\">\r\n            {{\r\n              purchaseItem.ProcessProviderId === ProcessProvider.VirtualEvent\r\n                ? ('marketplace-redeem-zoom' | translate)\r\n                : ('marketplace-redeem-now' | translate)\r\n            }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <hr class=\"mt-3 mx-2 mb-3\" />\r\n    <div class=\"row px-2\">\r\n      <div class=\"col-12 pl-1\">\r\n        <div class=\"row\">\r\n          <!--Points-->\r\n          <div class=\"col-5 d-flex align-items-center\">\r\n            <span\r\n              class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'purchase.wallet.points.spent.screenreader' | translate }}\"\r\n              >emoji_events</span\r\n            >\r\n            <span class=\"marketplace-wallet-points\">{{ purchaseItem.PointsValue | FortressCurrencyPipe: 'PTS' }}</span>\r\n          </div>\r\n          <!--Attributes-->\r\n          <div class=\"col-7 d-flex align-items-center\" *ngFor=\"let attribute of attributes; let i = index\">\r\n            <span\r\n              class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'wallet.attribute.screenreader' | translate }}\"\r\n              >tune</span\r\n            >\r\n            <span class=\"marketplace-wallet-attributes\">{{ attribute.ValueName }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <!--Custom Fields-->\r\n          <div\r\n            class=\"col-12 d-flex align-items-center pb-0 pt-3\"\r\n            *ngIf=\"purchaseItem.CustomFields && purchaseItem.CustomFields.length\"\r\n          >\r\n            <span\r\n              class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'wallet.custom.field.screenreader' | translate }}\"\r\n              >post_add</span\r\n            >\r\n            <ng-container *ngFor=\"let customField of purchaseItem.CustomFields; let i = index\">\r\n              <span class=\"marketplace-wallet-custom-field pr-1\">{{ customField.Value }}</span>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 d-flex justify-content-center align-items-center pt-3\">\r\n      <div>\r\n        <button\r\n          attr.aria-label=\"{{ purchaseItem.DisplayName }} wallet item - See More\"\r\n          class=\"btn py-1 dropdown-tog\"\r\n          [ngClass]=\"{ notOpen: !ShowMoreInfo }\"\r\n          type=\"button\"\r\n          (click)=\"ShowMoreInfo = !ShowMoreInfo\"\r\n        >\r\n          <div>\r\n            <div class=\"icon icon-arrow-1-up wallet-arrow-icon d-flex align-items-center\"></div>\r\n          </div>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"ShowMoreInfo\">\r\n      <div class=\"wallet-content col-12\">\r\n        <div class=\"marketplace-wallet-date-redeemed pt-5\">{{ 'marketplace.wallet.date.purchase' | translate }}</div>\r\n        <div class=\"font-size-14 mb-3\">{{ purchaseItem.ProcessDate | date: dateOption.LongDateFormat }}</div>\r\n        <div>\r\n          <label class=\"marketplace-wallet-description\">{{ 'wallet.description' | translate }}</label>\r\n          <fgbcl-short-long-description [description]=\"purchaseItem.DescriptionText\"></fgbcl-short-long-description>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <ng-container *fgbWebsiteContentFeatureFlag=\"'feature.flag.wallet.barcode'\">\r\n      <ng-container\r\n        *ngIf=\"\r\n          purchaseItem.ProcessProviderId != ProcessProvider.UniqueCode &&\r\n          purchaseItem.ProcessProviderId != ProcessProvider.VirtualEvent\r\n        \"\r\n      >\r\n        <div class=\"d-block d-lg-none\">\r\n          <div class=\"qr d-flex justify-content-center\">\r\n            <qrcode [qrdata]=\"purchaseItem.BarcodeText\" [size]=\"256\" [level]=\"'M'\" [usesvg]=\"true\"></qrcode>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"purchaseItem.RedeemStatus\">\r\n  <div class=\"wallet-container\">\r\n    <ngb-accordion #a=\"ngbAccordion\" [destroyOnHide]=\"false\" class=\"w-100\">\r\n      <ngb-panel id=\"ngb-panel-i-{{ purchaseItem.LogId }}\">\r\n        <ng-template ngbPanelHeader let-opened=\"opened\">\r\n          <div (click)=\"a.toggle('ngb-panel-i-{{purchaseItem.LogId}}')\">\r\n            <div class=\"row p-3\">\r\n              <div class=\"col-3 d-flex justify-content-left align-items-center\">\r\n                <img\r\n                  class=\"purchase-list-image shadow rounded\"\r\n                  [src]=\"\r\n                    purchaseItem.ItemImageURL ||\r\n                      purchaseItem.ImageURL ||\r\n                      purchaseItem.ItemThumbnailURL ||\r\n                      purchaseItem.ThumbnailURL | contentImage: '7'\r\n                  \"\r\n                  alt=\"\"\r\n                  [useDefault]=\"true\"\r\n                  [loyaltyType]=\"'marketplace'\"\r\n                  draggable=\"false\"\r\n                />\r\n              </div>\r\n              <div class=\"col-9\">\r\n                <div class=\"marketplace-wallet-title purchase-title text-left\">{{ purchaseItem.DisplayName }}</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-12 d-flex justify-content-center align-items-center mb-2\">\r\n            <div>\r\n              <button\r\n                attr.aria-label=\"{{ purchaseItem.DisplayName }} wallet item - See More\"\r\n                class=\"btn py-1 dropdown-tog\"\r\n                type=\"button\"\r\n                ngbPanelToggle\r\n              >\r\n                <div>\r\n                  <div class=\"icon icon-arrow-1-down marketplace-arrow-icon d-flex align-items-center\"></div>\r\n                </div>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent class=\"content-dropdown\">\r\n          <div class=\"row\">\r\n            <div class=\"content col-12 pl-4 pr-4\">\r\n              <ng-container *ngIf=\"!!purchaseItem.CustomFields || !!purchaseItem.AttributeValues\">\r\n                <div class=\"row pt-4\">\r\n                  <!--Points-->\r\n                  <div class=\"col-6 d-flex align-items-center pb-3\">\r\n                    <span\r\n                      class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n                      role=\"img\"\r\n                      attr.aria-label=\"{{ 'purchase.wallet.points.spent.screenreader' | translate }}\"\r\n                      >emoji_events</span\r\n                    >\r\n                    <span class=\"marketplace-wallet-points\">{{ purchaseItem.PointsValue | FortressCurrencyPipe: 'PTS' }}</span>\r\n                  </div>\r\n                  <!--Attributes-->\r\n                  <div class=\"col-6 d-flex align-items-center pb-3\" *ngFor=\"let attribute of attributes; let i = index\">\r\n                    <span\r\n                      class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n                      role=\"img\"\r\n                      attr.aria-label=\"{{ 'wallet.attribute.screenreader' | translate }}\"\r\n                      >tune</span\r\n                    >\r\n                    <span class=\"marketplace-wallet-attributes\">{{ attribute.ValueName }}</span>\r\n                  </div>\r\n                  <!--Custom Fields-->\r\n                  <div class=\"col-12 d-flex align-items-center pb-0\" *ngIf=\"!!purchaseItem.CustomFields\">\r\n                    <span\r\n                      class=\"material-icons redeem-list-item-icons text-grey mr-1\"\r\n                      role=\"img\"\r\n                      attr.aria-label=\"{{ 'wallet.custom.field.screenreader' | translate }}\"\r\n                      >post_add</span\r\n                    >\r\n                    <ng-container *ngFor=\"let customField of purchaseItem.CustomFields; let i = index\">\r\n                      <span class=\"marketplace-wallet-custom-field pr-1\">{{ customField.Value }}</span>\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n              <div class=\"marketplace-wallet-date-redeemed pt-3\">{{ 'marketplace.wallet.date.redeemed' | translate }}</div>\r\n              <div class=\"mb-3\">{{ purchaseItem.ProcessDate | date: dateOption.LongDateFormat }}</div>\r\n              <div class=\"pb-4 mb-2\">\r\n                <label class=\"marketplace-wallet-description\">{{ 'wallet.description' | translate }}</label>\r\n                <fgbcl-short-long-description [description]=\"purchaseItem.DescriptionText\"></fgbcl-short-long-description>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".purchase-list-image,.purchase-list-image img{width:50px;height:50px}.purchase-title{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.zoom-container{height:unset}@media (max-width:991px){.zoom-container{height:115px}}.zoom-container .zoom-call-btn{height:34px;width:142px;font-size:.875rem;font-weight:700}.redeem-card{padding:.75rem 1.25rem;min-height:170px}@media (max-width:991px){.redeem-card{min-height:307px}}.btn.notOpen{transform:rotate(180deg)}.icon-arrow-1-down{height:23px}"]
            }]
    }], function () { return [{ type: ɵngcc1.MemberQuery }, { type: ɵngcc1.MarketplaceExtendedQuery }]; }, { purchaseItem: [{
            type: Input
        }], dateOption: [{
            type: Input
        }] }); })();

class MemberPurchaseListItemModule {
}
MemberPurchaseListItemModule.ɵfac = function MemberPurchaseListItemModule_Factory(t) { return new (t || MemberPurchaseListItemModule)(); };
MemberPurchaseListItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MemberPurchaseListItemModule });
MemberPurchaseListItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            QRCodeModule,
            DirectivesModule,
            PipesModule,
            ShortLongDescriptionModule,
            NgbModule,
            RouterModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MemberPurchaseListItemModule, { declarations: function () { return [MemberPurchaseListItemComponent]; }, imports: function () { return [CommonModule,
        QRCodeModule,
        DirectivesModule,
        PipesModule,
        ShortLongDescriptionModule,
        NgbModule,
        RouterModule, ɵngcc9.TranslateModule]; }, exports: function () { return [MemberPurchaseListItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MemberPurchaseListItemModule, [{
        type: NgModule,
        args: [{
                declarations: [MemberPurchaseListItemComponent],
                imports: [
                    CommonModule,
                    QRCodeModule,
                    DirectivesModule,
                    PipesModule,
                    ShortLongDescriptionModule,
                    NgbModule,
                    RouterModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MemberPurchaseListItemComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MemberPurchaseListItemComponent, MemberPurchaseListItemModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-wallet-member-purchase-list-item.js.map